import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Title } from '../layout';

function invalidPath() {
  return (
    <div className="alert alert-danger">
      Invalid Path
    </div>
  )
}

class TouchpointListComponent extends Component {
  render() {
    const { programEnrollment, match } = this.props;
    const { params } = match;
    const { siteId, programId, touchpointFormId } = params;

    if(siteId === null || programId === null)
      return invalidPath();
    const site = programEnrollment.enrollment.sites.find(s => s.siteId === siteId);
    if (!site)
      return invalidPath();
    const program = site.programs.find(p => p.programId === programId);
    if (!program)
      return invalidPath();
    const tp = program.formPermissions.find(tp => tp.touchpointId === touchpointFormId);
    if (!tp)
      return invalidPath();

    const canCreate = tp.addPerm && tp.enabled;

    return (
      <div>
        <Title title="Form"/>
        <h1 className="page-header">
          { !tp.alias ? tp.externalName : tp.alias }
        </h1>

        <p>
          Form responses go here
        </p>

        {canCreate ? (
          <p>
            <Link to={`/sites/${tp.siteId}/programs/${tp.programId}/forms/${tp.touchpointId}/create`}
              className="btn btn-primary"
              role="button">
              Enter new { !tp.alias ? tp.externalName : tp.alias }
            </Link>
          </p>
        ) : ""}

        <table className="table table-striped">
          <thead>
            <tr>
              <th>Form Type</th>
              <th>Created At</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{ !tp.alias ? tp.externalName : tp.alias }</td>
              <td>01/23/2017</td>
            </tr>
            <tr>
              <td>{ !tp.alias ? tp.externalName : tp.alias }</td>
              <td>01/23/2017</td>
            </tr>
            <tr>
              <td>{ !tp.alias ? tp.externalName : tp.alias }</td>
              <td>01/23/2017</td>
            </tr>
            <tr>
              <td>{ !tp.alias ? tp.externalName : tp.alias }</td>
              <td>01/23/2017</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

TouchpointListComponent.propTypes = {
  auth: PropTypes.object.isRequired
};

const mapStateToProps = ({ auth, programEnrollment }) => {
  return {
    auth,
    programEnrollment
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TouchpointListComponent);



// WEBPACK FOOTER //
// src/touchpoints/touchpoint-list.component.js